import { selector } from '@poa/state';

export const filteredData = selector(store => {
  const seatchText = store.staff.filters.search;

  return store.staff.data.map((table, idx) => {
    let tbody = table.tbody;

    if (store.staff.filters.filtering.selected.value !== 'all') {
      tbody = tbody.filter(row => {
        if (row.group_id !== store.staff.filters.filtering.selected.value) {
          return false;
        }
        return true;
      });
    }

    // filter by input text
    if (seatchText !== '') {
      tbody = tbody.filter(row => {
        const isMatched = [];

        const searchAcc = ([cellKey, cellData]) => {
          const value = (cellData.value || '').toString().toLowerCase();
          const search = seatchText.toLowerCase();

          if (cellKey === 'is_active') {
            const transformedData = cellData.value ? 'активен' : 'неактивен';
            isMatched.push(transformedData === search);
            return;
          }

          if (cellData) {
            isMatched.push(value.includes(search));
          }
        };

        const sections = Object.keys(row);

        for (let i = 0, l = sections.length; i < l; i++) {
          const sectionId = sections[i];
          const sectionData = row[sectionId];

          if (sectionData) {
            // since we have status: "active" key here
            if (typeof sectionData === 'object') {
              Object.entries(sectionData).forEach(searchAcc);
            }
          }
        }

        return isMatched.some(Boolean);
      });
    }

    tbody = tbody.filter(row => row.status === 'active');

    return {
      thead: table.thead,
      tfoot: table.tfoot,
      title: table.title,
      tbody,
      _meta: table._meta
    };
  });
});

export const isAllColumnsSelected = selector(store => {
  return store.staff.selectors.selectedPreset.columnsConfiguration.every(c => c.isSelected);
});
